import React, { Component } from "react";
import { connect } from "react-redux";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  updateCurrentMenu,
  updateGoBackFromBookingOnlyCustomerPageModalVisibility
} from "../../../actions/menu";
import {
  resetCustomerProfileForm,
  updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile
} from "../../../actions/customerProfile";
import { Modal } from "semantic-ui-react";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import objectAssign from "object-assign";

@connect(mapStateToProps)
export default class GoBackFromBookingOnlyCustomerPageModal extends Component {
  constructor(props) {
    super(props);
  }

  goBackHandler = () => {
    let { locationToGoToFromCustomerPageModal } = this.props;

    this.closeModal();
    this.props.dispatch(updateCurrentMenu(locationToGoToFromCustomerPageModal));

    this.props.dispatch(updateGlobalErrorMessage(""));
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  closeAndSave = () => {
    let {
      customerProfileData,
      apiCustomerProfileData,
      bookingOnlyCustomerProfileData,
      appointmentStepData: { selectedCustomer },
      appointmentStepData,
      limitedPermissions,
      currentBookingId
    } = this.props;

    selectedCustomer.email = bookingOnlyCustomerProfileData.email;
    selectedCustomer.phone = bookingOnlyCustomerProfileData.phoneNumber;
    selectedCustomer.firstname = bookingOnlyCustomerProfileData.firstName;
    selectedCustomer.lastname = bookingOnlyCustomerProfileData.lastName;

    let canCreateCustomerByUsingBookingFormFields =
      !limitedPermissions.canCreateCustomerProfile &&
      !limitedPermissions.canSearchForCustomers &&
      (this.canEditCurrentBooking() || !currentBookingId);

    let newData = objectAssign({}, appointmentStepData, {
      selectedCustomer: selectedCustomer,
      address: canCreateCustomerByUsingBookingFormFields
        ? bookingOnlyCustomerProfileData.address
        : appointmentStepData.address
    });
    this.props.dispatch(updateAppointmentStepData(newData));

    this.props.dispatch(
      updateShouldSaveAppointmentOnceWeGoBackFromCustomerProfile(true)
    );
    setTimeout(() => {
      this.goBackHandler();
    }, 0); // this is required because the cb is not called after the customer has been updated in the app state, but rather, before that, so we wait until the next JS app cycle
  };

  closeModal = () => {
    let visible = false;
    this.props.dispatch(
      updateGoBackFromBookingOnlyCustomerPageModalVisibility(visible)
    );
  };

  render() {
    let {
      goBackFromBookingOnlyCustomerPageModalVisible,
      loadingCustomerProfile
    } = this.props;

    if (!goBackFromBookingOnlyCustomerPageModalVisible) {
      return "";
    }

    let discardChangesAndGoBack = () => {
      this.goBackHandler();
    };

    let saveButtonClasses = "ui button savebtn";
    let discardButtonClasses = "ui button cancel-btn";
    let { No, Yes } = window.APP.LANGUAGE.Shared.PopupWindows;

    if (loadingCustomerProfile) {
      saveButtonClasses += " loading";
      discardButtonClasses += " disabled";
    }

    return (
      <Modal
        className="bookingdetails-model go-back-from-booking-only-customer-page-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="save-box">
            <section className="header">
              {window.APP.LANGUAGE.Pages.CustomerProfile.SaveChanges}
              <button
                type="button"
                className="close_button"
                onClick={this.closeModal}
              ></button>
            </section>
            <section className="save_box_buttons">
              <div
                className={discardButtonClasses}
                onClick={discardChangesAndGoBack}
              >
                {No}
              </div>
              <div className={saveButtonClasses} onClick={this.closeAndSave}>
                {Yes}
              </div>
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    goBackFromBookingOnlyCustomerPageModalVisible:
      state.menuReducer.goBackFromBookingOnlyCustomerPageModalVisible,
    loadingCustomerProfile: state.customerProfileReducer.loadingCustomerProfile,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    currentBookingId: state.bookingReducer.currentBookingId,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    locationToGoToFromCustomerPageModal:
      state.menuReducer.locationToGoToFromCustomerPageModal
  };
}
